var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5V4.2C2 1.8804 3.79086 0 6 0C8.20914 0 10 1.8804 10 4.2V5H11.1429C11.616 5 12 5.448 12 6V15C12 15.552 11.616 16 11.1429 16H0.857143C0.384 16 0 15.552 0 15V6C0 5.448 0.384 5 0.857143 5H2ZM1 15H11V6H1V15ZM6.99769 11.2945L7.5 12.5H4.5L5.00231 11.2945C4.69414 11.0014 4.5 10.5747 4.5 10.1C4.5 9.2168 5.172 8.5 6 8.5C6.828 8.5 7.5 9.2168 7.5 10.1C7.5 10.5747 7.30586 11.0014 6.99769 11.2945ZM9 4.36C9 2.50432 7.65685 1 6 1C4.34315 1 3 2.50432 3 4.36V5H9V4.36Z",
    fill: "#3585F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.e9cb78506eda05c3869b902cf9a3e71c.svg";
export { ForwardRef as ReactComponent };